/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'live-feed': {
    width: 16,
    height: 13,
    viewBox: '0 0 16 13',
    data:
      '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 2.703C0 1.486.953.5 2.128.5h11.744C15.047.5 16 1.486 16 2.703v7.595c0 1.216-.953 2.202-2.128 2.202H2.128C.953 12.5 0 11.514 0 10.297V2.703zm2.128-.836c-.445 0-.807.374-.807.836v7.595c0 .46.362.835.807.835h11.744c.445 0 .807-.374.807-.835V2.702c0-.462-.362-.836-.807-.836H2.128z" _fill="#A363FF"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M3 6.5a.75.75 0 01.75-.75H7.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.5zM3 8.75A.75.75 0 013.75 8h6a.75.75 0 010 1.5h-6A.75.75 0 013 8.75zM11.25 6.5a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75zM11.25 4.25A.75.75 0 0112 3.5h.75a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75zM11.25 8.75A.75.75 0 0112 8h.75a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75zM3 4.25a.75.75 0 01.75-.75H9A.75.75 0 019 5H3.75A.75.75 0 013 4.25z" _fill="#A363FF"/>'
  }
})
